package de.oevbs.kunde.kundenportal2.authentication

import dev.fritz2.core.Handler
import dev.fritz2.core.RootStore
import kotlinx.coroutines.*
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map
import kotlinx.datetime.*
import kotlin.math.max

object SessionTimerStore : RootStore<Long>(initialData = SessionTime.MAX_DURATIONS_SECONDS, Job()) {

    /**
     * Returns the Unix epoch [sessionTimeSeconds] from now in seconds.
     */
    private fun getSessionEndEpochSeconds(): Long =
        Clock.System.now().plus(SessionTime.MAX_DURATIONS_SECONDS, DateTimeUnit.SECOND).epochSeconds

    private var timerJob: Job? = null

    private fun updatePeriodically(): Job =
        (MainScope() + job).launch {
            val logoutEpochSeconds = getSessionEndEpochSeconds()
            for (s in 0 until SessionTime.MAX_DURATIONS_SECONDS) {
                delay(1000)
                val remainingSeconds = logoutEpochSeconds - Clock.System.now().epochSeconds
                update(max(0, remainingSeconds))
            }
        }

    val restart: Handler<Unit> = handle { _ ->
        timerJob?.cancel()
        timerJob = updatePeriodically()
        SessionTime.MAX_DURATIONS_SECONDS
    }

    val cancel: Handler<Unit> = handle { current ->
        timerJob?.cancel()
        timerJob = null
        current
    }

    /**
     * `true`, wenn der Timer durch Ablaufen der Zeit einen Wert gleich oder kleiner 0 erreicht.
     *
     * Dies ist dann der Fall, wenn der Timer regulär (ohne manuellen Logout) abläuft. Wird ein manueller Logout
     * ausgeführt (unter Benutzung von [cancel]), wird der TimerStore nicht zurückgesetzt und dieser Wert emittiert
     * weiterhin `false`.
     */
    val hasExpired: Flow<Boolean> = data.map { it <= 0L }
}